
import Home from '../Pages/Home'
import UserProfile from '../Pages/UserProfile'
import EditProfile from '../Pages/EditProfile'
import Category from '../Pages/Category'
import ProductSingle from '../Pages/ProductSingle'
import ProductList from '../Pages/ProductList'
import Saved from '../Pages/Saved'
import Messages from '../Pages/Messages'
import Filters from '../Pages/Filters'
import Search from '../Pages/Search'
import StoreList from '../Pages/StoreList'
import Favorites from '../Pages/Favorites'
import StoreSingle from '../Pages/StoreSingle'
import Report from '../Pages/Report'
import Score from '../Pages/Score'
import Chat from '../Pages/Chat'
import AddItem from '../Pages/AddItem'
import Rule from '../Pages/Rule'
import MessageSuport from '../Pages/MessageSuport'
import Support from '../Pages/Support'
import Ticket from '../Pages/Support/Ticket'
import Settings from '../Pages/Settings'
import Notification from '../Pages/Notification'
import DeleteItem from '../Pages/DeleteItem'
import VisitIncrease from '../Pages/VisitIncrease'
import CensusAndVisit from '../Pages/CensusAndVisit'
import MyProducts from '../Pages/MyProducts'
import ShowImages from '../Pages/ShowImages'
import Result from '../Pages/ResultPayment'
import Complaint from '../Pages/Complaint'
const UserRoute = [
    {
        path: "/",
        user: false,
        element: <Home />,
    },
    {
        path: "/UserProfile",
        user: true,
        element: <UserProfile />,
    },

    {
        path: "/EditProfile",
        user: true,
        element: <EditProfile />,
    },
    {
        path: "/Category",
        user: false,
        element: <Category />,
    },
    {
        path: "/item/:id",
        user: false,
        element: <ProductSingle />,
    },
    {
        path: "/ShowImages",
        user: false,
        element: <ShowImages />,
    },
    {
        path: "/ProductList",
        user: false,
        element: <ProductList />,
    },
    {
        path: "/Saved",
        user: true,
        element: <Saved />,
    },
    {
        path: "/Messages",
        user: true,
        element: <Messages />,
    },
    {
        path: "/Filters",
        user: false,
        element: <Filters />,
    },
    {
        path: "/Search",
        user: false,
        element: <Search />,
    },
    {
        path: "/StoreList",
        user: false,
        element: <StoreList />,
    },
    {
        path: "/Favorites",
        user: false,
        element: <Favorites />,
    },
    {
        path: "/StoreSingle/:id/:user_id",
        user: false,
        element: <StoreSingle />,
    },
    {
        path: "/Report",
        user: false,
        element: <Report />,
    },
    {
        path: "/Score",
        user: false,
        element: <Score />,
    },
    {
        path: "/Chat",
        user: true,
        element: <Chat />,
    },

    {
        path: "/AddItem",
        user: true,
        element: <AddItem />,
    },

    {
        path: "/Rule",
        user: false,
        element: <Rule />,
    },
    {
        path: "/MessageSuport",
        user: false,
        element: <MessageSuport />,
    },
    {
        path: "/Support",
        user: false,
        element: <Support />,
    },
    {
        path: "/Ticket/:id",
        user: false,
        element: <Ticket />,
    },
    {
        path: "/Settings",
        user: false,
        element: <Settings />,
    },
    {
        path: "/Notification",
        user: true,
        element: <Notification />,
    },
    {
        path: "/DeleteItem/:id",
        user: true,
        element: <DeleteItem />,
    },
    {
        path: "/VisitIncrease/:id",
        user: true,
        element: <VisitIncrease />,
    },
    {
        path: "/CensusAndVisit/:id",
        user: true,
        element: <CensusAndVisit />,
    },
    {
        path: "/MyProducts",
        user: true,
        element: <MyProducts />,
    },
    {
        path: "/EditItem/:id",
        user: true,
        element: <AddItem />,
    },
    {
        path: "/complaint",
        element: <Complaint />,
    },
    {
        path: "/result-payment/:code",
        element: <Result />,
    },
    
];

export { UserRoute };  